module.exports = __webpack_public_path__ + "static/img/banner-1.40eef80.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce/banner-1.jpg
// module id = yKC3
// module chunks = 1